export default {
      id: "rosatom-usage",
      viewBox: "0 0 160 57",
      url: __webpack_public_path__ + "sprite.svg#rosatom-usage",
      toString: function () {
        return this.url;
      }
    }